export default {
	CheckStatusSupplier: "Check supplier's activity status",
	Check: 'Check',
	PlaceholderSearch: 'Enter name, tax code to search',
	NameSupplier: 'Unit name',
	NameSupplierNew: 'Supplier/customer name',
	TaxCode: 'Tax Code',
	TaxCodeStructure: 'Supplier tax code (10 or 14 character structure)',
	PersonalIdCode: 'Identification number',
	PersonalIdCodeStructure: 'ID card of business household head for suppliers that are business households (12 character structure)',
	TotalInvoice: 'Quantity',
	ActiveStatus: 'Status',
	DateCheck: 'Checking date',
	SupplierCode: 'Unit code',
	SupplierCodeNew: 'Unit code',
	Edit: 'Edit',
	Import: 'Import',
	ImportExcel: 'Import from excel',
	CheckAgain: 'Check again',
	Export: 'Export',
	InfoSupplier: 'Supplier/customer name',
	Address: 'Address',
	InfoSupplierAccept: 'Supplier/customer information is accepted ',
	SuccessEditSupplier: 'Edit successfully',
	InfoAccept: 'Names/addresses are accepted',
	StartDate: 'Start date',
	EndDate: 'End date',
	PersonAccept: 'Acceptor',
	WarningDataChange:
		'&lt;span class="title-toast-message"&gt;The data has not been saved.&lt;/span&gt;&lt;br&gt;Are you sure you want to cancel?',
	ImportSupplierCode: 'Import supplier information',
	ImportFile: '1. Download the import file',
	StepChooseFile: 'Choose file',
	MergeInfo: '2. Merge information fields',
	StepMergeData: 'Merge data',
	CheckData: '3. Check data',
	StepPreviewData: 'Preview data',
	Result: '4. Import',
	StepResult: 'Result',
	Continue: 'Continue',
	Cancel: 'Cancel',
	Back: 'Revert',
	Next: 'Next',
	CheckDuplicate: 'Check duplicate',
	ColDataApp: 'Data columns on the software',
	ColDataFile: 'Data columns on data files',
	Instructions: 'Data entry instructions',
	ActionExistInfo: 'When encountering information already on the system:',
	Skip: 'Skip',
	Update: 'Update',
	SelectFile: 'Select a data file',
	ChooseFileData: 'Select data file',
	PleaseUploadFileFirst: 'Please upload a data file before continuing.',
	ReplaySelectFile: 'Select other file',
	UploadSuccess: 'File uploaded successfully or ',
	DragDropFile: 'Drag and drop the source file here',
	Or: 'Or',
	OrDragDropFile: 'or drag and drop the source file here',
	Line: '___________',
	FormatFile: 'The program only supports files in *.xls, *.xlsx, *.csv, *.ods formats',
	OrChooseFrom: 'or choose from',
	Computer: 'Computer',
	FileFormat: 'Formats XLSX, XLS, ODS',
	Note: 'Note:  ',
	ResultNote: 'For the most accurate import results use the template file.',
	UploadFilePatern: 'Load the sample file',
	SampleFileDesc: 'Includes required fields and some basic information',
	SheetImport: 'Import sheet',
	LineTitle: 'Header row',
	LineText: 'Lines',
	All: 'All',
	Invalid: 'Valid',
	NotInvalid: 'Invalid',
	DowloadFileResult: 'Download the data results file',
	LoadImport: 'Importing supplier/customer codes',
	NoficationWaitImport:
		'The import of the supplier/customer code may take a few minutes, the program will display a message when the import is completed',
	Close: 'Close',
	ImportSuccess: 'Import successful',
	ImportResultTitle: 'Import result',
	BackToList: 'Back to list',
	ImportResultCompleted: 'The file import process has been completed with the result:',
	AddSuccess: 'Success',
	AddFail: 'Failure',
	line: 'lines',
	MessageMisMatched:
		'Column <Supplier/customer code, supplier/customer name, Tax Code>, on the program is not matching any data column in the import file. Do you want to keep importing?',
	CompanyName: 'Company',
	BranchName: 'Branch',
	DepartmentName: 'Department',
	MemberName: `Member's name`,
	ProvinceCode: 'Province Code',
	ProvinceName: 'Province Name',
	DistrictCode: 'District Code',
	DistrictName: 'District Name',
	InfoUnit: 'Unit information',
	InfoPayment: 'Payment information',
	InfoContact: 'Contact information',
	NumberAccount: 'Account number',
	NameAccount: 'Account name',
	BankName: 'Bank name',
	Branch: 'Branch',
	NameBank: 'Bank name',
	Agency: 'Branch',
	NameContact: "Contact person's full name",
	Email: 'Email',
	PhoneNumber: 'Phone number',
	Position: 'Position',
	PaymentDueDate: 'Payment due date',
	SupplierNameNew: 'Suppliers/customers',
	PlaceholderSearchNew: 'Enter supplier/customer name, tax code/identification number to search',
	AdviseUse: 'Usage advice',
	ChooseFileWithExtension: 'Please select a file with the format (*.xls,*.xlsx,*.csv,*.ods)',
	CannotFindSheetOnDocument: 'Sheet not found on document',
	DateFromCreateInvoice: 'from create invoice',
	WatchGuidHere: 'See setup guide',
	LogAlertDeleteInfo: {
		FirtsText: 'Delete acceptable name/address information of',
		SecondText: 'effective from date',
		EndText: 'to date'
	},
	LogAlertEditInfo: {
		FirtsText: 'Edit acceptable name/address information',
		SecondText: 'from',
		EndText: 'to'
	},
	PersonContact: 'Contact name',
	SupplierCodeDetail: 'Unit code',
	SupplierName: 'Supplier name',
	ColNotMatchData: {
		FirstText: 'Column',
		SecondText: 'on the software is not matching any data column in the import file. Do you want to keep importing',
		WarningText: (mes1, mes2) => `Column ${mes1} is being merged with column ${mes2} on the data file.`,
		WarningText1: 'Do you want to keep importing?'
	},
	FilterSupplier: 'Filter category',
	ActiveStatusSupplier: 'Supplier/customer status',
	ActiveStatusSupplierNew: 'Activity status',
	RiskStatusInvoice: 'Invoice risk status',
	PlaceholderBranchSearch: 'Enter name of branch/department to search',
	InformationIsAccepted: 'Additional accepted information',
	TitleInfoAccept: 'Supplier/customer information is accepted',
	EditSupplier: 'Edit supplier/customer',
	AddressBusinessInvalid: 'The business address does not coincide with the representative office',
	MergeInfoCol: {
		SupplierCode: 'unit code',
		SupplierCode1: 'unit code',
		TaxCode: 'tax code',
		TaxCode1: 'tax code',
		SellerName: 'supplier/customer name',
		SellerName1: 'supplier/customer name',
		PaymentDueDate: 'payment due date',
		PaymentDueDate1: 'payment due date',
		AccountNumber: 'account number',
		AccountNumber1: 'account number',
		AccountName: 'account name',
		AccountName1: 'account name',
		BankName: 'bank name',
		BankName1: 'bank name',
		Branch: 'branch',
		NameContact: 'contact name',
		NameContact1: 'contact name',
		Email: 'email',
		PhoneNumber: 'phone number',
		PhoneNumber1: 'phone number',
		Position: 'position'
	},
	Tooltip: {
		SupplierName: 'Supplier name'
	},
	ActiveSeller: {
		Active1: 'Taxpayer temporarily suspends business',
		Active2: 'Active payer (granted tax registration certificate)',
		Active3: 'Taxpayer is not active at the registered address',
		Active4: 'Operating business (granted tax code notice)',
		Active5: 'Taxpayer stops working but has not completed the procedure to close tax code',
		Active6: 'Taxpayer stopped working and closed tax code',
		Active7: 'Operating business (granted tax registration certificate)',
		Active8: 'The taxpayer has transferred to the tax authority',
		Active9: 'Active taxpayer (granted tax code notice)',
		Active10: 'Taxpayer waiting for bankruptcy procedures',
		Active11: 'Taxpayer has been granted tax code',
		Active12: 'Taxpayer waiting for verification of operational status at registered address',
		Active13: 'Tax code waiting for personal identification information update'
	},
	RiskStatus: {
		Risky: 'High risk of taxes and invoices according to official dispatches from the Tax Authority',
		RiskDocument: document => `High risk of taxes and invoices according to Official dispatch ${document}`,
		NoRisk: 'Not in the high risk tax and invoice list',
		RiskyActiveStatus: 'There is a high risk of taxes and invoices',
		TooltipRiskyActiveStatus: `There is a high risk of taxes and invoice due to the operating status being "NNT operating at the registered address" at invoice date`,
		TitleHistoryActiveStatus: 'Operational status history',
		ResultUpdateHistory: 'Results updated from date '
	},
	CheckOneSupplierCompleted: 'Supplier/Customer check completed',
	CheckOneSupplierFailed: 'Supplier/Customer check failed',
	CheckAllSupplierCompleted: 'Supplier/Customer check completed',
	HistoryVatRate: 'History of Goods Tax Rates',
	HistoryVat: 'History of Tax Rates'
};
